// Sentry frontend instrumentation.
//
// Phase 0 of the perf plan (docs/superpowers/plans/2026-04-17-phase0-1a-1c-perf.md).
// Captures: JS errors, unhandled promise rejections, route transactions,
// Web Vitals (FCP, LCP, CLS, INP), and — on errors only — replay sessions.
//
// The DSN is public by design. It's write-only: an attacker who scrapes it
// can only send events to our project, not read them. Safe to ship in a
// production bundle. Absence of DSN is a no-op, so dev builds without a
// VITE_SENTRY_DSN env var skip init entirely.
import * as Sentry from '@sentry/react';

export function initSentry(): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) {
    if (import.meta.env.DEV) {
      console.log('Sentry: no DSN set, skipping init');
    }
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_RELEASE_SHA ?? 'unknown',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // 20% of transactions traced in perf. Cheap on free tier, enough signal.
    tracesSampleRate: 0.2,
    // Don't record sessions by default — only when an error is hit.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
  });
}
